export default "__VITE_ASSET__BQsPXhmq__"